import type { AllergenId } from "./types";

/** The 14 EU allergens in the regulation's order, with their Italian names. The ids are the backend's. */
export const ALLERGENS: readonly { id: AllergenId; name: string }[] = [
  { id: "glutine", name: "Glutine" },
  { id: "crostacei", name: "Crostacei" },
  { id: "uova", name: "Uova" },
  { id: "pesce", name: "Pesce" },
  { id: "arachidi", name: "Arachidi" },
  { id: "soia", name: "Soia" },
  { id: "latte", name: "Latte" },
  { id: "frutta_a_guscio", name: "Frutta a guscio" },
  { id: "sedano", name: "Sedano" },
  { id: "senape", name: "Senape" },
  { id: "sesamo", name: "Sesamo" },
  { id: "solfiti", name: "Solfiti" },
  { id: "lupini", name: "Lupini" },
  { id: "molluschi", name: "Molluschi" },
];

const NAMES = new Map<string, string>(ALLERGENS.map((a) => [a.id, a.name]));

/** The allergen's Italian name; an id the list does not know shows as it is. */
export const allergenName = (id: string): string => NAMES.get(id) ?? id;
